export default __webpack_public_path__ + "static/media/logo-i.d34ad6fc.svg";